import AppForm from '../app-components/Form/AppForm';

Vue.component('app-factory-transaction-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                name:  '' ,
                admin_user_id:  '' ,
                app_offices_id:  '' ,
                app_factories_id:  '' ,
                app_payment_id:  '' ,
                
            },
            factorySourceData:null,
            tempFactory: null
        }
    },
    methods:{
        uploadFile(evt){

            const superObj = this

            this.factorySourceData = []

            this.sourceFile = this.$refs.file.files[0]
            const formData = new FormData();
            formData.append('sourcefile', this.sourceFile);
            const headers = { 'Content-Type': 'multipart/form-data' };

            axios.post(`${this.action}/upload-factory-transaction`, formData, { headers }).then((res) => {

                console.log("res", res)
                const result = res.data
                const { data } = result
                console.log('data', data)
                this.factorySourceData = data
            
            }).catch(function (error) {
                this.factorySourceData = []
                if (error.response) {
                    const { message, statusText } = error.response.data
                    const { message: axiosMessage } = error
                    superObj.$notify({
                        type: 'error',
                        title: 'Error!',
                        text: `${message} (${axiosMessage})`
                    });
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
            
              });
        }
    },
    props: {
        headersImport:{
            type: Array,
            default:[
            ]
        }
    }

});